export const formatTimestamp = (timestamp, options = {}) => {
  if (!timestamp) return '—';
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    ...options,
  });
};

export const formatChartTime = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

export const formatAxisValue = (value) => {
  if (value == null || Number.isNaN(value)) return '—';
  return Number(value).toFixed(3);
};

export const formatTemperature = (value) => {
  if (value == null || Number.isNaN(value)) return '—';
  return `${Number(value).toFixed(1)}°C`;
};

export const severityClass = (severity) => {
  switch (severity) {
    case 'elevated': return 'sev-yellow';
    case 'significant': return 'sev-orange';
    case 'critical': return 'sev-red';
    default: return '';
  }
};
